/**
 * vue 基础库
 */
(function (global, factory) {
    var theExports = null;
    var hasModuleExports = false;
    if(typeof module === "object" && typeof module.exports === "object") {
        theExports = module.exports;
        hasModuleExports = true;
    } else {//导出为模块
        theExports = global['App_Map'] = {};
    }
    factory(theExports, hasModuleExports);
}(typeof window !== "undefined" ? window : this, function (exports, hasModuleExports) {
    exports.__name__ = 'App_Map';
    //
    if(hasModuleExports) {
        console.log('以模块方式导入[' + exports.__name__ + ']');
    }
    else {
        console.log('以普通方式导入[' + exports.__name__ + ']');
    }
    //---------------------------------------------------------------------------------
    let {Utils} = require('./app.base');
    let appConf = require('./app.conf');
    let {Vue} = require('./app.vues');
    //---------------------------------------------------------------------------------

    let CoordTrans = window.coordtransform || undefined // require('coordtransform');
    if(typeof CoordTrans == 'undefined') {
        console.warn('缺少 coordtransform.js');
    }

    let BaiduMap = window.VueBaiduMap ? window.VueBaiduMap.default : undefined //require('vue-baidu-map');
    if(typeof BaiduMap == 'undefined') {
        console.warn('缺少 vue-baidu-map.js');
    }

    //
    Vue.use(BaiduMap, {
        // ak 是在百度地图开发者平台申请的密钥 详见 http://lbsyun.baidu.com/apiconsole/key */
        ak: appConf.bdMapAppKey
    });

    //----------------------------------- exports -------------------------------------
    let __to_be_exported = {
        CoordTrans,
        //
        BaiduMap
    };

    Utils.merge(exports, __to_be_exported);
}));




//////////////////
// WEBPACK FOOTER
// ./src/app.map.js
// module id = 152
// module chunks = 1